import React, { useMemo, useState } from 'react';
import { FiArrowRight } from 'react-icons/fi';
import projects from '../../projectsData';
import useInView from '../../useInView';
import {
  Main,
  MaxWidth,
  Title,
  Heading,
  Filters,
  FilterBtn,
  Grid,
  Card,
  Thumb,
  Tag,
  Body,
  CardTop,
  CardTitle,
  Year,
  Desc,
  TechRow,
  TechChip,
  ViewMore,
} from './Projects.elements';

const head = {
  hidden: { opacity: 0, y: 20 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: 0.08 * i, ease: 'easeOut' },
  }),
};

function Projects() {
  const categories = useMemo(
    () => ['All', ...Array.from(new Set(projects.map((p) => p.category)))],
    []
  );
  const [active, setActive] = useState('All');
  const [gridRef, gridInView] = useInView({ amount: 0.05 });

  const filtered =
    active === 'All' ? projects : projects.filter((p) => p.category === active);

  return (
    <Main id="projects">
      <MaxWidth>
        <Title variants={head} initial="hidden" animate="visible">
          Selected work
        </Title>
        <Heading variants={head} custom={1} initial="hidden" animate="visible">
          My Projects
        </Heading>

        <Filters>
          {categories.map((c) => (
            <FilterBtn
              key={c}
              $active={active === c}
              onClick={() => setActive(c)}
            >
              {c}
            </FilterBtn>
          ))}
        </Filters>

        <Grid ref={gridRef}>
          {filtered.map((p, i) => (
            <Card
              key={p.slug}
              to={`/project/${p.slug}`}
              initial={{ opacity: 0, y: 30 }}
              animate={
                gridInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }
              }
              transition={{
                duration: 0.5,
                delay: 0.05 * (i % 6),
                ease: 'easeOut',
              }}
            >
              <Thumb>
                <img src={p.gallery[0]} alt={p.title} />
                <Tag>{p.category}</Tag>
              </Thumb>
              <Body>
                <CardTop>
                  <CardTitle>{p.title}</CardTitle>
                  <Year>{p.year}</Year>
                </CardTop>
                <Desc>{p.short}</Desc>
                <TechRow>
                  {p.tech.slice(0, 4).map((t) => (
                    <TechChip key={t}>{t}</TechChip>
                  ))}
                </TechRow>
                <ViewMore>
                  View details <FiArrowRight />
                </ViewMore>
              </Body>
            </Card>
          ))}
        </Grid>
      </MaxWidth>
    </Main>
  );
}

export default Projects;
